import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { TicketTypeService } from '../../../../../../common/services/TicketType.service';
import { TicketTypeConst } from './ticket-type.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import * as _ from 'lodash';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
@Component({
  selector: 'settings-tickets-ticket-type',
  templateUrl: './ticket-type.component.html',
  styleUrls: ['./ticket-type.component.css'],
  providers: [TicketTypeService, BsModalService],
})
@Injectable()
export class TicketTypeComponent extends BaseListComponent {
  @ViewChild('templateType') templateType: ElementRef;
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public modelFilter: any = {};

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private typeService: TicketTypeService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = TicketTypeConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }
  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    const payload = await this.buildBasePayload(request, sort);
    this.typeService
      .list(payload)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.data = res.data.types;
            this.data.map(res => {
              res.display_type = TicketTypeConst.displayTypeColumn(res.tenant_id);
              return res;
            });
            this.initPage(res.data.total);
          } else {
            this.throwError();
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
  }
  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({ name: this.modelFilter.keyword.trim() });
    } else {
      await this.loadData();
    }
  }
  async setUpModel(type) {
    this.typeModal = type;
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới loại ticket' : 'Cập nhật loại ticket',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên loại ticket',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'description',
        label: 'Mô tả',
        type: FormFieldType.Text,
        value: this.model.description,
        required: false,
        disabled: false,
        width: 'full',
        order: 1,
      },
    ];
  }

  async add(payload) {
    this.typeService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async edit(id, payload) {
    this.typeService.update(id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.typeService._delete(this.delete_id).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        await this.setUpModel('add');
        this.openModal(this.templateType, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        await this.setUpModel('edit');
        this.openModal(this.templateType, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        this.delete_id = item.id;
        await this.openConfirmDelete();
        break;
    }
  }
  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    const payload = {
      name: this.model.name,
      description: this.model.description,
    };
    if (this.typeModal === 'add') {
      await this.add(payload);
    } else if (this.typeModal === 'edit') {
      await this.edit(this.model.id, payload);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/ticket-type/ticket-type.component.ts